module.exports = __webpack_public_path__ + "img/TUR-A-1-I.bd8a4e7f.png";